"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SocialsWrapper = require("./SocialsWrapper");
Object.keys(_SocialsWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialsWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialsWrapper[key];
    }
  });
});